import React, { Component } from 'react';
import { HeaderSub2 } from '../../Common/HeaderSub2'
import { HeaderSub } from '../../Common/HeaderSub'
import { CategoryReg } from './CategoryReg';
import { ColorReg } from './ColorReg';
import { GoodsReg } from './GoodsReg';
import { GoodsPre } from './GoodsPre';
import { MaterialReg } from './MaterialReg';
import { MaterialDtl } from './MaterialDtl';
import { PhotoUpload } from './PhotoUpload';
import { SizeReg } from './SizeReg';

import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:상품등록 마스터 페이지
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.GoodsReg,  //기본 컴포넌트 할당
            ContentState: null
        };
    }
    //호출할 컴포넌트 이름
    CompName = {
        "CategoryReg": "CategoryReg",
        "ColorReg": "ColorReg",
        "GoodsReg": "GoodsReg",
        "GoodsPre": "GoodsPre",
        "MaterialReg": "MaterialReg",
        "MaterialDtl": "MaterialDtl",
        "PhotoUpload": "PhotoUpload",
        "SizeReg": "SizeReg"
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.GoodsReg) {
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="나의상품"
                        LinkUrl="/"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsReg
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            if (this.state.RenderName === this.CompName.CategoryReg) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle="카테고리"
                            ComponentUrl="GoodsReg"
                            RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                            ComponentName={this.state.RenderName}
                        />
                        <CategoryReg
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            else if (this.state.RenderName === this.CompName.ColorReg) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle="색상"
                            ComponentUrl="GoodsReg"
                            RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                            ComponentName={this.state.RenderName}
                        />
                        <ColorReg
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            else if (this.state.RenderName === this.CompName.GoodsPre) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle="미리보기"
                            ComponentUrl="GoodsReg"
                            RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                            ComponentName={this.state.RenderName}
                        />
                        <GoodsPre
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            else if (this.state.RenderName === this.CompName.MaterialReg) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle="소재"
                            ComponentUrl="GoodsReg"
                            RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                            ComponentName={this.state.RenderName}
                        />
                        <MaterialReg
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            else if (this.state.RenderName === this.CompName.MaterialDtl) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle="소재혼용율입력"
                            ComponentUrl="MaterialReg"
                            RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                            ComponentName={this.state.RenderName}
                        />
                        <MaterialDtl
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            else if (this.state.RenderName === this.CompName.PhotoUpload) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle="사진추가"
                            ComponentUrl="GoodsReg"
                            RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                            ComponentName={this.state.RenderName}
                        />
                        <PhotoUpload
                            ComponentName={this.CompName.PhotoUpload} /* 페이지 내부에 권한 체크 기능이 있어 props 추가  */
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            else if (this.state.RenderName === this.CompName.SizeReg) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle="사이즈"
                            ComponentUrl="GoodsReg"
                            RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                            ComponentName={this.state.RenderName}
                        />
                        <SizeReg
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            
        }
    }  

    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
